#import "./newsletter-stub-fragment.graphql"

fragment NewsletterFragment on Campaign {
    ...NewsletterStubFragment
    archivedEditionCount
    nextSendingEdition {
        id
        name
        scheduledTime
        htmlUrlPath
    }
}
